import type { GodchildBonusType } from 'digicel-kaizen-library';
import FormatService from './format';
import { formatValue } from './usage-formatters';

export const formatGodchildBonuses = (godchild: GodchildBonusType) => {
  const { credits, price } = godchild;

  return [price && FormatService.formatCentsToCurrency(price, true)]
    .concat(Object.values(credits).map(credit => formatValue(credit.value, credit.unit)))
    .filter(Boolean)
    .join(', ');
};
